export default "__VITE_ASSET__DsUtlw$e__"